import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=1e5028bf&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=1e5028bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5028bf",
  null
  
)

export default component.exports